module.exports = __webpack_public_path__ + "img/miya_bg.c80e4118.jpg";